var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoResult(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 2.31389C70.1107 2.31389 89.6861 21.9356 89.6861 46C89.6861 70.0645 70.0644 89.6862 46 89.6862C21.9356 89.6862 2.31382 70.0645 2.31382 46C2.31382 21.9356 21.9356 2.31389 46 2.31389ZM46 0C20.5935 0 -6.10352e-05 20.5936 -6.10352e-05 46C-6.10352e-05 71.4065 20.5935 92.0001 46 92.0001C71.4064 92.0001 92 71.4065 92 46C92.0463 20.5936 71.4527 0 46 0Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9999 88.0198C69.207 88.0198 88.02 69.2067 88.02 45.9997C88.02 22.7926 69.207 3.97949 45.9999 3.97949C22.7928 3.97949 3.97972 22.7926 3.97972 45.9997C3.97972 69.2067 22.7928 88.0198 45.9999 88.0198Z",
    fill: "url(#paint0_radial_531_19344)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45.4,
    y: 39,
    width: 2.26274,
    height: 9.05096,
    rx: 1.13137,
    transform: "rotate(45 45.4 39)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 40.5996,
    width: 2.26274,
    height: 9.05096,
    rx: 1.13137,
    transform: "rotate(-45 39 40.5996)",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3496 57.6879C56.0508 57.6879 56.5183 57.4541 56.9858 56.9866C57.9208 56.0517 57.9208 54.6492 56.9858 53.7143L52.311 49.0395C53.4797 47.4033 53.9472 45.2996 53.9472 43.196C53.9472 37.1187 49.0386 32.2102 42.9614 32.2102C36.8841 31.9764 31.9756 36.885 31.9756 42.9622C31.9756 49.0395 36.8841 53.948 42.9614 53.948C45.065 53.948 47.1687 53.2468 48.8049 52.0781L53.4797 56.7529C54.1809 57.4541 54.6484 57.6879 55.3496 57.6879ZM42.9614 49.2732C39.4553 49.2732 36.6504 46.4683 36.6504 42.9622C36.6504 39.4561 39.689 36.6512 42.9614 36.6512C46.2337 36.6512 49.2724 39.4561 49.2724 42.9622C49.2724 46.4683 46.4675 49.2732 42.9614 49.2732Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.687 24.9639H55.3496C53.9472 24.9639 53.0122 25.8988 53.0122 27.3013C53.0122 28.7037 53.9472 29.6387 55.3496 29.6387H57.687C60.2582 29.6387 62.3618 31.7423 62.3618 34.3135V36.8846C62.3618 38.2871 63.2968 39.222 64.6992 39.222C66.1017 39.222 67.0366 38.2871 67.0366 36.8846V34.3135C67.0366 29.1712 62.8293 24.9639 57.687 24.9639Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6992 53.0127C63.2968 53.0127 62.3618 53.9477 62.3618 55.3501V57.6875C62.3618 60.2586 60.2582 62.3623 57.687 62.3623H55.3496C53.9472 62.3623 53.0122 63.2973 53.0122 64.6997C53.0122 66.1021 53.9472 67.0371 55.3496 67.0371H57.687C62.8293 67.0371 67.0366 62.8298 67.0366 57.6875V55.3501C67.0366 53.9477 66.1017 53.0127 64.6992 53.0127Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6504 62.3623H34.313C31.7418 62.3623 29.6382 60.2586 29.6382 57.6875V55.3501C29.6382 53.9477 28.7032 53.0127 27.3008 53.0127C25.8983 53.0127 24.9634 53.9477 24.9634 55.3501V57.6875C24.9634 62.8298 29.1707 67.0371 34.313 67.0371H36.6504C38.0528 67.0371 38.9878 66.1021 38.9878 64.6997C38.9878 63.2973 38.0528 62.3623 36.6504 62.3623Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3008 38.9883C28.7032 38.9883 29.6382 38.0533 29.6382 36.6509V34.3135C29.6382 31.7423 31.7418 29.6387 34.313 29.6387H36.6504C38.0528 29.6387 38.9878 28.7037 38.9878 27.3013C38.9878 25.8988 38.0528 24.9639 36.6504 24.9639H34.313C29.1707 24.9639 24.9634 29.1712 24.9634 34.3135V36.6509C24.9634 37.8196 25.8983 38.9883 27.3008 38.9883Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_531_19344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9999 45.9996) rotate(-90) scale(42.0202 41.5124)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04AEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoResult);
export default __webpack_public_path__ + "static/media/icon_no_result.e1315a2913b15de6763d807a8d49e444.svg";
export { ForwardRef as ReactComponent };